import React from 'react';
import { Row, Col } from 'react-grid-system';
import { defaultTextStyle } from 'settings/theme';
import TimezoneSelect from './TimezoneSelect';
import DateSelect from './DateSelect';
import TimeSelect from './TimeSelect';
import Dropdown from 'components/vistaprintUILibrary/Dropdown';
import { getLocalizedText } from '@vp-dst/localization-util';

function Scheduler(props) {
  const {
    selectedTimezone,
    selectedDate,
    selectedTime,

    selectedDesigner,
    previousDesigners,
    selectedDesignerOnChange,

    timezones,
    availableDates,
    availableTimes,
    availableDatesLoading,
    availableTimesLoading,
    refreshAvailableDates,
    refreshAvailableTimes,
    setAvailableDatesError,
    setAvailableTimesError,
    selectedDateOnChange,
    selectedTimeOnChange,
    timezoneOnChange,
  } = props;

  return (
    <Row>
      <Col xs={12}>
        <Row>
          <Col xs={12}
            style={{
              marginTop: 20,
            }}
          >
            <div
              style={{
                width: '100%',
                marginBottom: 20,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div style={{
                flexGrow: 1,
                marginBotton: 10,
              }}>
                <TimezoneSelect
                  selectedTimezone={selectedTimezone}
                  timezones={timezones}
                  timezoneOnChange={timezoneOnChange}
                />
              </div>
              <div>
                {previousDesigners && previousDesigners.length > 0 && (
                  <Dropdown id="designer-dropdown" onChange={selectedDesignerOnChange}>
                    <option value='' selected={selectedDesigner === ''}>
                      {getLocalizedText('scheduler-any-designer')}
                    </option>
                    {previousDesigners.map(d =>
                      (<option value={d.CalendarId} selected={selectedDesigner === d.CalendarId}>{d.Name}</option>)
                    )}
                  </Dropdown>
                )}
              </div>
            </div>
          </Col>
        </Row>
        {selectedTimezone &&
          <Row>
            <Col xs={12}>
              <DateSelect
                loading={availableDatesLoading}
                errorMessage={setAvailableDatesError}
                refreshAvailableDates={refreshAvailableDates}
                availableDates={availableDates}
                selectedDate={selectedDate}
                selectedDateOnChange={selectedDateOnChange}
                numDatesToShowPerPage={7}
                totalDatesToShow={14}
              />
            </Col>
          </Row>
        }
        {!selectedTimezone &&
          <div style={{
            ...defaultTextStyle,
            width: '100%',
            fontSize: '2em',
            textAlign: 'center',
            marginTop: 10,
            marginBottom: 10
          }}>
            {getLocalizedText('choose-timezone-first')}
          </div>
        }
        <Col xs={12}>
          {!availableDatesLoading && availableDates.length !== 0 &&
            <TimeSelect
              loading={availableTimesLoading}
              errorMessage={setAvailableTimesError}
              refreshAvailableTimes={refreshAvailableTimes}
              selectedTime={selectedTime}
              availableTimes={availableTimes}
              selectedTimezone={selectedTimezone}
              selectedTimeOnChange={selectedTimeOnChange}
            />
          }
        </Col>
      </Col>
    </Row>
  );
}

export default Scheduler;



// WEBPACK FOOTER //
// ./src/components/Scheduler/index.js